import { THideItem } from '#/types/hideItem';

export const HidenItemsActionType = {
  HIDEN_ITEMS_ADD_HIDEN_ITEM: 'hidenItems/add_hidenItem',
  HIDEN_ITEMS_REMOVE_HIDEN_ITEM: 'hidenItems/remove_hidenItem',
  HIDEN_ITEMS_REMOVE_ALL_HIDEN_ITEMS: 'hidenItems/remove_all_hidenItems',
} as const;

export type THidenItemsActions =
  | {
      type: typeof HidenItemsActionType.HIDEN_ITEMS_ADD_HIDEN_ITEM;
      payload: THideItem;
    }
  | {
      type: typeof HidenItemsActionType.HIDEN_ITEMS_REMOVE_HIDEN_ITEM;
      payload: THideItem;
    }
  | {
      type: typeof HidenItemsActionType.HIDEN_ITEMS_REMOVE_ALL_HIDEN_ITEMS;
      payload: THideItem['type'];
    };
